module.exports = __webpack_public_path__ + "static/Pollinator_s Menu detail 1-9d16d66064735534fef003fe1e8454ed.jpg";